import React from 'react';
import { Menu } from 'lucide-react';

export default function Header({ companyName, onMenuClick }) {
  return (
    <header className="h-16 lg:h-20 bg-white border-b border-slate-200 flex items-center px-4 sm:px-6 lg:px-8 justify-between sticky top-0 z-40">
      <div className="flex items-center gap-4">
        <button 
          onClick={onMenuClick}
          aria-label="Abrir menu de navegação"
          aria-expanded="false"
          className="lg:hidden p-2 text-slate-600 hover:bg-slate-100 rounded-lg transition-colors"
        >
          <Menu />
        </button>
        <div className="flex flex-col">
          <h1 className="text-xs text-slate-500 font-medium">Gestão Pro</h1>
          <h2 className="font-bold text-slate-900 truncate max-w-[70vw] sm:max-w-none">{companyName}</h2>
        </div>
      </div>
    </header>
  );
}

